export default __webpack_public_path__ + "static/media/icon-close.cef81609.svg";